import { useState, useEffect } from 'react';

export default function useDevices() {
    const [devices, setDevices] = useState([]);
    const [isMediaDeviceValidated, setIsMediaDeviceValidated] = useState(false);
    useEffect(() => {
        let getDevices = null;
        if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
            getDevices = () => navigator.mediaDevices.enumerateDevices().then(devices => setDevices(devices));
            navigator.mediaDevices.addEventListener('devicechange', getDevices);
            getDevices();
            setIsMediaDeviceValidated(true);
        }
        return () => {
            if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                navigator.mediaDevices.removeEventListener('devicechange', getDevices);
            }
        };
    }, []);

    return {
        audioInputDevices: devices.filter(device => device.kind === 'audioinput'),
        videoInputDevices: devices.filter(device => device.kind === 'videoinput'),
        audioOutputDevices: devices.filter(device => device.kind === 'audiooutput'),
        hasAudioInputDevices: devices.filter(device => device.kind === 'audioinput').length > 0,
        hasVideoInputDevices: devices.filter(device => device.kind === 'videoinput').length > 0,
        isMediaDeviceValidated
    };
}